// BudgetBazaar

import React from 'react'
import { BudgetBazaarbox } from './BudgetBazaarbox'

export const BudgetBazaar = () => {
    return (
        <>


            <div style={{ display: "flex",marginTop:"43px" }}>
                <div>
                    <img  src="https://cdn.shopclues.com/images/banners/PricePont_akb_1Oct21_W_01.jpg" alt="" />
                </div>
                <div>
                    <img  src="https://cdn.shopclues.com/images/banners/PricePont_akb_1Oct21_W_02.jpg" alt="" />
                </div>
                <div>
                    <img  src="https://cdn.shopclues.com/images/banners/PricePont_akb_1Oct21_W_03.jpg" alt="" />
                </div>
                <div>
                    <img  src="https://cdn.shopclues.com/images/banners/PricePont_akb_1Oct21_W_04.jpg" alt="" />
                </div>
                <div>
                    <img  src="https://cdn.shopclues.com/images/banners/PricePont_akb_1Oct21_W_05.jpg" alt="" />
                </div>
            </div>
            <BudgetBazaarbox />
        </>
    )
}
